/** Presentation timing only: never used by chart, report, payment, or analytics logic. */
export function revealTiming(index: number, compact = false) {
  const order = Math.max(0, Math.min(3, Math.floor(Number.isFinite(index) ? index : 0)));
  return { duration: compact ? 420 : 680, delay: order * (compact ? 35 : 65), distance: compact ? 9 : 18 };
}

export function readingProgress(top: number, height: number, viewport: number) {
  const travel = height - viewport;
  if (!Number.isFinite(top) || !Number.isFinite(travel) || travel <= 0) return 0;
  return Math.max(0, Math.min(1, -top / travel));
}
